<template>
  <!-- 信息流广告 --> 
  <YorkbbsInfoflowItem v-if="data.app === 'crm_ad'" :data="data"></YorkbbsInfoflowItem>
  <!-- 人工置顶 -->
  <a class="post-item manual" target="_blank" :href="url" v-else-if="operType == 1">
    <div class="post-detail">
      <div class="post-title" v-html="title"></div>
      <div class="post-desc">
        <span class="post-label__top">置顶</span>
        <span class="post-time">{{ publishTime | timeToStr }}</span>
      </div>
    </div>
    <YorkbbsImage class="post-cover" aspect animation :src="imageList[0] | webpFormat(200)" v-if="imageList[0]"></YorkbbsImage>
  </a>
  <!-- 三图 -->
  <a class="post-item multi" target="_blank" :href="detailURL" v-else-if="coverImage.length === 3">
    <div class="post-title__wrapper">
      <span class="post-title" v-html="title"></span>
    </div>
    <div class="post-cover__list">
      <YorkbbsImage
        class="post-cover__item"
        animation
        aspect
        v-for="(cover, i) in coverImage"
        :key="i"
        :src="cover | webpFormat(200)"
      ></YorkbbsImage>
    </div>
    <div class="post-desc">
      <span class="post-label__top" v-if="isTop">置顶</span>
      <template v-else>
        <span class="post-topic__special" v-if="isSpecial">专题</span>
        <span class="post-topic" v-if="!isSpecial">{{ topic.name }}</span>
      </template>
      <span class="post-time">{{ publishTime | timeToStr }}</span>
    </div>
  </a>
  <!-- 单图 -->
  <a class="post-item single" target="_blank" :href="detailURL" v-else>
    <div class="post-detail">
      <div>
        <span class="post-title" v-html="title"></span>
      </div>
      <div class="post-desc">
        <span class="post-label__top" v-if="isTop">置顶</span>
        <template v-else>
          <span class="post-topic__special" v-if="isSpecial">专题</span>
          <span class="post-topic" v-if="!isSpecial">{{ topic.name }}</span>
        </template>
        <span class="post-time">{{ publishTime | timeToStr }}</span>
      </div>
    </div>
    <YorkbbsImage class="post-cover" aspect animation :src="coverImage[0] | webpFormat(200)" v-if="coverImage[0]"></YorkbbsImage>
  </a>
</template>
<script>
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue';
import { hostBuild } from '@/utils/utils';
export default {
  name: 'CmsItemPost',
  components: { YorkbbsInfoflowItem },
  props: { data: Object },
  computed: {
    operType() {
      return this.data.operType;
    },
    app() {
      return this.data.app;
    },
    // 标题
    title() {
      return this.data.title;
    },
    // 人工置顶地址
    url() {
      return this.data.url;
    },
    // 发布时间
    publishTime() {
      return this.data.property.publishTime;
    },
    coverImage() {
      let imgArr = [];
      if( this.data.property.coverImage && this.data.property.coverImage.length >0 ){
        imgArr = this.data.property.coverImage;
      }else{
        let maxLg = this.data.imageList.length <3 ? this.data.imageList.length:3;
        imgArr = this.data.imageList.slice(0,maxLg);
      }
      return imgArr;
    },
    imageList() {
      return this.data.imageList || [];
    },
   
    // 版块列表
    topics() {
      return this.data.property.topic || [];
    },
    // 新闻所属版块
    topic() {
      const $topic = this.$route.params.topic;
      const topic = this.topics.find(t => t.englishName === $topic);
      return topic ? topic : this.topics[0];
    },
    // 是否置顶
    isTop() {
      return this.data.property.top == 1;
    },
    // cmsTYpe 信息类型，1 普通新闻 2 新闻专题；3 生活专题；4自定义专题
    cmsType() {
      return this.data.property.cmsType;
    },
    // 生活专题类型，1 大专题；2 小专题
    topicType() {
      return this.data.property.topicType;
    },
    isSpecial() {
      return [2, 3, 4].includes(this.cmsType);
    },
    // 详情页地址
    detailURL() {
      if (this.data.property.jumpLink) {
        return this.data.property.jumpLink;
      } else if (this.cmsType === 3) {
        return hostBuild(`/special/${this.topicType == 1 ? 'big' : 'small'}/${this.data.id}`, 'info');
      } else if ([2, 4].includes(this.cmsType)) {
        return hostBuild(`/feature/${this.topic.englishName}/${this.data.id}`,'news');
      }

      return hostBuild(`/detail/${this.topic.englishName}/${this.data.id}`,'news');
    },
  },
};
</script>
<style lang="less" scoped>
.post-item {
  margin-bottom: 30px;
  &.manual,
  &.single {
    display: flex;
  }
  &.multi {
    display: block;
  }
}
.post-detail {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.post-cover {
  margin-left: 20px;
  width: 30%;
  
  border-radius: 4px;
  border: 1px solid #eee;
}

.post-title__wrapper {
  margin-bottom: 12px;
}
.post-title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #111;
  &:hover {
    color: #e43a3a;
  }
}
.post-desc {
  margin-top: 8px;
}
.post-label__top,
.post-topic__special {
  font-size: 14px;
  line-height: 20px;
  color: #e43a3a;
  margin-right: 20px;
}
.post-topic,
.post-time {
  font-size: 14px;
  line-height: 20px;
  color: #999;
  margin-right: 20px;
}

.post-cover__list {
  display: flex;
  justify-content: space-between;
  margin:0 -10px;
  margin-bottom: 12px;
}
.post-cover__item {
  flex:1;margin: 0 10px;
  border-radius: 4px;
  border: 1px solid #eee;
}
</style>
